import style from "./header.module.scss";
import LogoImage from "../../../static/images/medline-logo.svg";
import MenuIcon from "../../../static/images/menu_logo.svg";

export const LogoMenuBlock = ({ homeOrigin, onOpen }) => (
  <div className={`d-flex align-items-center ${style.main_logo}`}>
    <div className={`${style.medline_log}`}>
      <a href={homeOrigin}>
        <img src={LogoImage} alt="Logo" className="img-fluid" />
      </a>
    </div>
    <div className={`${style.menu_log}`} onClick={onOpen}>
      <img src={MenuIcon} alt="Open menu" className="img-fluid" />
    </div>
    <div className={`${style.menu_content}`} onClick={onOpen}>
      <p>Menu</p>
    </div>
  </div>
);
